<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-12">
          <div class="pull-right" style="margin-bottom: 6px;">
            <input type="search" class="form-control input-sm" placeholder="Search records" v-model="searchQuery" aria-controls="datatables">
          </div>
        </div>
        <div class="col-sm-12">
          <el-table id="notifications-table"
                    class="wrap-whole-words"
                    :row-class-name="getNotificationClass"
                    :data="queriedData"
                    border
                    style="width: 100%">
            <el-table-column label="Message" min-width="300">
              <template slot-scope="props">
                <div v-if="props.row.entityType === constants.ENTITIES.PROJECT">
                  <a @click="handleEditProject(props.row)" href="#">{{ props.row.message }}</a>
                </div>
                <div v-else-if="props.row.entityType === constants.ENTITIES.JOB">
                  <a @click="handleEditJob(props.row)" href="#">{{ props.row.message }}</a>
                </div>
                <div v-else-if="props.row.entityType === constants.ENTITIES.TASK">
                  <a @click="handleEditTask(props.row)" href="#">{{ props.row.message }}</a>
                </div>
                <div v-else-if="props.row.entityType === constants.ENTITIES.COMMENT">
                  <a @click="handleEditComment(props.row)" href="#">{{ props.row.message }}</a>
                </div>
                <div v-else-if="props.row.entityType === constants.ENTITIES.COMPANY">
                  Please check all the department note tabs in "{{ props.row.message }}" <a @click.prevent="handleEditCompany(props.row)" href="#">View Company</a>
                </div>
                <div v-else-if="props.row.route && props.row.message">
                  <router-link @click.native="updateSeenAt(props.row)" :to="props.row.route">{{ props.row.message }}</router-link>
                </div>
                <div v-else-if="props.row.message">
                 {{ props.row.message }}
                </div>
                <div v-else>
                  Error message is missing :`(
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Type" min-width="100">
              <template slot-scope="props">
                {{ getEntityTypeDisplayName(props.row.entityType) }}
              </template>
            </el-table-column>
            <el-table-column label="From" min-width="125">
              <template slot-scope="props">
                {{ props.row.fromUserId === '0' ? "System" : getUserDisplayName(props.row.fromUserId) }}
              </template>
            </el-table-column>
            <el-table-column label="Date" min-width="150">
              <template slot-scope="props">
                {{ props.row.createdAt | formatDate }}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="120"
              fixed="right"
              label="Actions">
              <template slot-scope="props">
                <a v-if="!props.row.seenAt" href="#" @click="updateSeenAtAndNotify(props.row)">Mark as Seen</a>
              </template>
            </el-table-column>
          </el-table>
          <div class="col-md-12 btn-see-more-container">
            <button type="button" @click="markAllAsSeen" :disabled="noNotifications" class="btn btn-fill btn-info btn-see-more">
              Mark all as Seen
            </button>
            <button type="button" @click="fetchOneMoreWeek" class="btn btn-fill btn-info btn-see-more">
              see more &hellip;
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {weeksAgo, notificationSeenNotSeen, notifySuccess, notifyWarning, notifyError} from 'src/utilities/utils'
  import Constants from 'src/utilities/constants'
  import {OK} from 'http-status-codes'

  export default {
    computed: {
      ...mapGetters({
        user: 'security/user',
        userId: 'security/userId',
        tableData: 'users/notifications/results'
      }),
      noNotifications() {
        return this.tableData.length === 0
      },
      queriedData () {
        if (!this.searchQuery) {
          return this.tableData
        }
        return this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
      }
    },
    data() {
      return {
        constants: Constants,
        numWeeksToFetch: 1,
        searchQuery: '',
        propsToSearch: ['message']
      }
    },
    methods: {
      getUserDisplayName(userId) {
        if (!userId) {
          return ''
        }
        return this.$store.getters['users/displayName'](userId)
      },
      getEntityTypeDisplayName(entityType) {
        return entityType === 'PtracTask' ? 'Task' : entityType
      },
      getNotificationClass(data) {
        return notificationSeenNotSeen(data.row)
      },
      fetchOneMoreWeek() {
        this.numWeeksToFetch++
        this.loadNotifications(this.numWeeksToFetch)
      },
      async updateSeenAt(notification) {
        const putPayload = this.$store.getters['users/notifications/putPayload'](notification)
        return await this.$store.dispatch('put', putPayload)
      },
      async updateSeenAtAndNotify (notification) {
        const response = await this.updateSeenAt(notification)
        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          notifySuccess(this, "Notification marked as seen")
          await this.loadNotifications(this.numWeeksToFetch)
        }
      },
      load1WeeksNotifications() {
        this.loadNotifications(1)
      },
      async loadNotifications(numWeeks) {
        if (!this.userId) {
          return
        }
        const payload = {
          userId: this.userId,
          createdAt: weeksAgo(numWeeks)
        }
        const response = await this.$store.dispatch('users/notifications/fetchNWeeksNotifications', payload)

        if (OK !== response.status) {
          notifyError(this, 'Failed to retrieve notifications')
          return
        }

        if (response.data.length === 0) {
          notifyWarning(this, 'No Notifications Found')
        }
      },
      async markAllAsSeen() {
        const response = await this.$store.dispatch('users/notifications/markAllAsSeen', {
          userId: this.userId,
          createdAt: weeksAgo(this.numWeeksToFetch).replace(/-/g, '/')
        })

        if (OK === response.status) {
          await this.loadNotifications(this.numWeeksToFetch)
          notifySuccess(this, 'All Notifications Marked as Seen')
        }
      },
      handleEditProject(notification) {
        this.updateSeenAt(notification)
        this.$router.push({path: `/projects/${notification.route}`})
      },
      handleEditCompany(notification) {
        this.updateSeenAt(notification)
        this.$eventHub.$emit('show-modal-2', 'Company', {id: notification.route}, '1000px')
      },
      handleEditComment (notification) {
        this.updateSeenAt(notification)
        this.$router.push({path: notification.route})
      },
      handleEditJob(notification) {
        this.updateSeenAt(notification)
        this.$eventHub.$emit('show-modal-1', 'Edit Job', {id: notification.route})
      },
      handleEditTask (notification) {
        this.updateSeenAt(notification)
        this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: notification.route})
      }
    },
    mounted () {
      this.$store.cache.dispatch('users/fetchAll')
      this.load1WeeksNotifications()
    }
  }
</script>
<style scoped>
  .btn-see-more-container {
    text-align: center;
  }
  .btn-see-more {
    margin-top: 10px
  }
</style>
